import { render, staticRenderFns } from "./DocumentStatusEdit.vue?vue&type=template&id=fa05ca62&"
import script from "./DocumentStatusEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentStatusEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports